import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Box,
  IconButton,
  Badge,
  Tooltip,
  alpha,
  useTheme,
} from '@mui/material';
import {
  TrendingDown,
  Analytics,
  Notifications,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function DowntrendHeader({ alertCount, onAlertsClick, onOpenIndicators }) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2.25 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{
          width: 38,
          height: 38,
          borderRadius: 1.25,
          background: `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${theme.palette.error.dark} 100%)`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: `0 4px 14px ${alpha(theme.palette.error.main, 0.3)}`,
        }}>
          <TrendingDown sx={{ fontSize: 22, color: '#fff' }} />
        </Box>
        <Box>
          <Typography sx={{ fontSize: '1.18rem', fontWeight: 800, color: '#1e293b', letterSpacing: -0.3, lineHeight: 1.15 }}>
            {t('downtrend.title')}
          </Typography>
          <Typography sx={{ fontSize: '0.7rem', color: '#94a3b8', fontWeight: 500 }}>
            {t('downtrend.subtitle')}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {alertCount > 0 && (
          <Tooltip title={`${alertCount} cảnh báo đang hoạt động`}>
            <Badge
              badgeContent={alertCount}
              color="error"
              sx={{ '& .MuiBadge-badge': { fontSize: '0.75rem', height: 20, minWidth: 20, fontWeight: 700 } }}
            >
              <IconButton
                size="small"
                onClick={onAlertsClick}
                sx={{ bgcolor: alpha(theme.palette.error.main, 0.1), '&:hover': { bgcolor: alpha(theme.palette.error.main, 0.2) } }}
              >
                <Notifications sx={{ color: theme.palette.error.main, fontSize: 20 }} />
              </IconButton>
            </Badge>
          </Tooltip>
        )}
        <Tooltip title="Xem chỉ số vĩ mô">
          <IconButton
            size="small"
            onClick={onOpenIndicators}
            sx={{ bgcolor: alpha(theme.palette.primary.main, 0.1), '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.2) } }}
          >
            <Analytics sx={{ color: theme.palette.primary.main, fontSize: 20 }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}

DowntrendHeader.propTypes = {
  alertCount: PropTypes.number.isRequired,
  onAlertsClick: PropTypes.func.isRequired,
  onOpenIndicators: PropTypes.func.isRequired,
};

export default DowntrendHeader;
